<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">通知日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.dr_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <span class="weui-form-preview__value">{{item.dr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商</label>
            <span class="weui-form-preview__value">{{item.dr_vendname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购单号</label>
            <span class="weui-form-preview__value">{{item.dr_maincode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">明细序号</label>
            <span class="weui-form-preview__value">{{item.dr_detaildetno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.dr_prcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购数量</label>
            <span class="weui-form-preview__value">{{item.pd_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求数量</label>
            <span class="weui-form-preview__value">{{item.dr_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已发货数量</label>
            <span class="weui-form-preview__value">{{item.dr_endqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.dr_demand_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{item.dr_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{item.dr_is_end ? "关闭" : "开启"}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var item = this.$route.params.item
    return {
      item,
    }
  }
}
</script>